var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "layout" },
    [
      _c("div", { staticClass: "layout__header" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "layout__controls" }, [
          _c("div", { staticClass: "form-inline" }, [
            _c(
              "div",
              { staticClass: "form-field" },
              [
                _c(
                  "input-field",
                  {
                    attrs: {
                      id: "cupo_maximo",
                      placeholder: "$ #,###.##",
                      vMoney: "",
                      format: _vm.money
                    },
                    model: {
                      value: _vm.cupoMaximo,
                      callback: function($$v) {
                        _vm.cupoMaximo = $$v
                      },
                      expression: "cupoMaximo"
                    }
                  },
                  [_vm._v("\n            Cupo máximo global\n          ")]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.cupoMaximo != "",
                    expression: "cupoMaximo != ''"
                  }
                ],
                staticClass: "btn-primary",
                attrs: { type: "button" },
                on: { click: _vm.actualizarCupos }
              },
              [
                _c("i", { staticClass: "fa fa-refresh" }),
                _c("span", [_vm._v("Actualizar cupos globales")])
              ]
            ),
            _vm._v(" "),
            _vm.puedeCrear
              ? _c(
                  "button",
                  {
                    staticClass: "btn-primary",
                    attrs: { type: "button" },
                    on: { click: _vm.crear }
                  },
                  [
                    _c("i", { staticClass: "fa fa-plus" }),
                    _c("span", [_vm._v("Nuevo")])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn-info",
                attrs: { type: "button" },
                on: { click: _vm.consultar }
              },
              [
                _c("i", { staticClass: "fa fa-search" }),
                _c("span", [_vm._v("Consultar")])
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn-success",
                attrs: { type: "button" },
                on: { click: _vm.exportarExcel }
              },
              [
                _c("i", { staticClass: "fa fa-file-excel-o" }),
                _c("span", [_vm._v("Exportar")])
              ]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card mb-2" }, [
        _c("div", { staticClass: "card__content" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-xs-12 col-md-6" }, [
              _c("div", { staticClass: "form-inline" }, [
                _c("strong", [_vm._v("Estados:")]),
                _vm._v(" "),
                _c("label", { attrs: { for: "activosParam" } }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.estadoP,
                        expression: "form.estadoP"
                      }
                    ],
                    attrs: { id: "activosParam", type: "radio", value: "A" },
                    domProps: { checked: _vm._q(_vm.form.estadoP, "A") },
                    on: {
                      change: function($event) {
                        return _vm.$set(_vm.form, "estadoP", "A")
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Activos")])
                ]),
                _vm._v(" "),
                _c("label", { attrs: { for: "inactivosParam" } }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.estadoP,
                        expression: "form.estadoP"
                      }
                    ],
                    attrs: { id: "inactivosParam", type: "radio", value: "I" },
                    domProps: { checked: _vm._q(_vm.form.estadoP, "I") },
                    on: {
                      change: function($event) {
                        return _vm.$set(_vm.form, "estadoP", "I")
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Inactivos")])
                ]),
                _vm._v(" "),
                _c("label", { attrs: { for: "todosParam" } }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.estadoP,
                        expression: "form.estadoP"
                      }
                    ],
                    attrs: { id: "todosParam", type: "radio", value: "T" },
                    domProps: { checked: _vm._q(_vm.form.estadoP, "T") },
                    on: {
                      change: function($event) {
                        return _vm.$set(_vm.form, "estadoP", "T")
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Todos")])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-12 col-md-6" }, [
              _c("div", { staticClass: "form-inline" }, [
                _c("strong", [_vm._v("Cobro:")]),
                _vm._v(" "),
                _c("label", { attrs: { for: "incobrablesCobroParam" } }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.tipoEstadoP,
                        expression: "form.tipoEstadoP"
                      }
                    ],
                    attrs: {
                      id: "incobrablesCobroParam",
                      type: "radio",
                      value: "I"
                    },
                    domProps: { checked: _vm._q(_vm.form.tipoEstadoP, "I") },
                    on: {
                      change: function($event) {
                        return _vm.$set(_vm.form, "tipoEstadoP", "I")
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Incobrables")])
                ]),
                _vm._v(" "),
                _c("label", { attrs: { for: "activosCobroParam" } }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.tipoEstadoP,
                        expression: "form.tipoEstadoP"
                      }
                    ],
                    attrs: {
                      id: "activosCobroParam",
                      type: "radio",
                      value: "A"
                    },
                    domProps: { checked: _vm._q(_vm.form.tipoEstadoP, "A") },
                    on: {
                      change: function($event) {
                        return _vm.$set(_vm.form, "tipoEstadoP", "A")
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Activos")])
                ]),
                _vm._v(" "),
                _c("label", { attrs: { for: "todosCobroParam" } }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.tipoEstadoP,
                        expression: "form.tipoEstadoP"
                      }
                    ],
                    attrs: { id: "todosCobroParam", type: "radio", value: "T" },
                    domProps: { checked: _vm._q(_vm.form.tipoEstadoP, "T") },
                    on: {
                      change: function($event) {
                        return _vm.$set(_vm.form, "tipoEstadoP", "T")
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Todos")])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-12 col-md-6" }, [
              _c(
                "div",
                { staticClass: "form-field" },
                [
                  _c(
                    "input-field",
                    {
                      attrs: {
                        id: "buscar",
                        placeholder: "Realice una consulta..."
                      },
                      model: {
                        value: _vm.form.searchP,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "searchP", $$v)
                        },
                        expression: "form.searchP"
                      }
                    },
                    [_vm._v("\n              Consultar:\n            ")]
                  )
                ],
                1
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-xs-12" },
          [
            _c("k-table", {
              ref: "listaClientes",
              attrs: {
                createButton: false,
                editButton: _vm.puedeEditar,
                deleteButton: _vm.puedeAnular,
                path: _vm.path,
                params: _vm.form,
                buscarButton: false,
                columns: [
                  {
                    display: "Identificación",
                    value: "numero_identificacion"
                  },
                  {
                    display: "Apellidos",
                    value: "apellidos_completos"
                  },
                  {
                    display: "Nombres",
                    value: "nombres_completos"
                  },
                  {
                    display: "Estado cobro",
                    value: "descripcion_tipo_estado"
                  },
                  {
                    display: "Teléfonos",
                    value: "telefonos"
                  },
                  {
                    display: "Celulares",
                    value: "celulares"
                  },
                  {
                    display: "Dirección",
                    value: "direccion"
                  },
                  {
                    display: "Cupo máximo",
                    value: "cupo_maximo"
                  },
                  {
                    display: "Creador",
                    value: "creador.nombre"
                  },
                  {
                    display: "Creación",
                    value: "created_at"
                  },
                  {
                    display: "Modificador",
                    value: "modificador.nombre"
                  },
                  {
                    display: "Modificación",
                    value: "updated_at"
                  }
                ]
              },
              on: { editar: _vm.editar, eliminar: _vm.eliminar }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            name: "cliente",
            scrollable: "",
            reset: "",
            adaptive: "",
            resizable: "",
            height: "auto",
            width: "65%",
            clickToClose: false
          }
        },
        [
          _c("cliente", {
            attrs: {
              puedeCrear: _vm.puedeCrear,
              clienteId: _vm.clienteId,
              puedeVerClaveAccesoWeb: _vm.puedeVerClaveAccesoWeb
            },
            on: {
              fotosGuardadas: function($event) {
                _vm.$modal.hide("cliente")
                _vm.consultar()
              },
              guardar: function($event) {
                _vm.$modal.hide("cliente")
                _vm.consultar()
              },
              cerrar: function($event) {
                return _vm.$modal.hide("cliente")
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__title" }, [
      _c("h3", [_vm._v("Clientes")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a483ae2a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a483ae2a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/logistica/clientes/ListaClientes.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-a483ae2a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/logistica/clientes/ListaClientes.vue
// module chunks = 0